import SpecialsPage from 'src/dispensary/specials';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

SpecialsPage.layout = CoreMenuLayout;
export default SpecialsPage;
